import { render, staticRenderFns } from "./VTextFieldDatePicker.vue?vue&type=template&id=54bba804"
import script from "./VTextFieldDatePicker.vue?vue&type=script&lang=ts"
export * from "./VTextFieldDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports